import { temAcesso } from '@/shared/auth/temAcesso'

const AtaDirex = () => import('./AtasDirex.vue')
const AtaDirexDetalhar = () => import('./detalhes/AtaDirexDetalhar.vue')
//const EncaminharProcessosAtaDirex = () => import('./EncaminharProcessosAtaDirex.vue')
//const CadProcessosAtaDirex = () => import('./cadastro/CadProcessosAtaDirex.vue')

export default {
    path: 'atas',
    name: 'Atas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('ATADIREX-00')) {
            next()
        }
    },
    children: [
        {
            path: '/atadirex',
            name: 'AtasDirex',
            component: AtaDirex,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ATADIREX-00')) {
                    next()
                }
            }
        },
        {
            path: '/atadirex/detalhes/:idAtaDirex/:tabindex/:mostrarModal/:nuSituacaoAta',
            name: 'AtaDirexDetalhes',
            component: AtaDirexDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ATADIREX-11')) {
                    next()
                }
            }
        }
        /*,
        {
            path: '/atadirex/cadastro/:idAtaDirex',
            name: 'ProcessosAtaDirex',
            component: CadProcessosAtaDirex,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ATADIREX-00')) {
                    next()
                }
            }
        }*/
    ]
}
